/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Create_Private_HintInputs */



/**
* | output |
* | --- |
* | "Created personas are private and only visible to you." |
*
* @param {Personas_Create_Private_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_create_private_hint = /** @type {((inputs?: Personas_Create_Private_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Create_Private_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellte Personas sind privat und nur für Sie sichtbar.")
	return /** @type {LocalizedString} */ ("Created personas are private and only visible to you.")
});